import React from 'react';
import NumberFormat from 'react-number-format';

export default function PriceFormat({ className, value, element = 'span', prefix = '', suffix = '' }) {
    const Element = element || 'span';

    return (
        <NumberFormat
            value={value}
            displayType={'text'}
            decimalSeparator={','}
            thousandSeparator={'.'}
            prefix={prefix !== '' ? prefix : '€ '}
            suffix={suffix}
            fixedDecimalScale={true}
            decimalScale={2}
            renderText={(formatValue) => {
                return (
                    <Element className={className}>
                        {formatValue.replace(',00', '')}
                    </Element>
                )
            }}
        />
    );
}
